import angular from "angular";
import {hasNoLocation} from './location-method-format';

angular
    .module('ui-common')
    .directive('mapIconImage', MapIconImageDirective);

function MapIconImageDirective() {
    var directive = {
        restrict: 'A',
        scope: {
            severity: '@',
            locationMethod: '@',
            beaconType: '@',
            selected: '@'
        },
        template: '<img title="{{ mapIconTitle }}" class="{{ mapIconClass }}" ng-src="{{ mapIconSource }}"/>',
        link: link
    };
    return directive;

    function link(scope, element, attrs, controller) {
        scope.mapIconSource = null;

        scope.$watch(
            function () {
                return attrs;
            },
            function (value) {
                if (!value) {
                    return;
                }

                scope.mapIconTitle = attrs.severity + '-' + (hasNoLocation(attrs.locationMethod) ? 'no-location' :
                    (attrs.locationMethod.toLowerCase() === 'gps' ? 'gps-location' : 'network-location'));

                scope.mapIconClass = hasNoLocation(attrs.locationMethod) ? 'img-diamond' :
                    (attrs.locationMethod.toLowerCase() === 'gps' ? 'img-circle' : 'img-square');
                if (attrs.beaconType == "Sentinel 100A" || attrs.beaconType == "Mobile SDK Anchor")
                    scope.mapIconSource = '../img/' + attrs.severity + '-anchor' +
                        (attrs.selected === 'true' ? '-selected' : '') + '.png';
                else
                    scope.mapIconSource = '../img/' + attrs.severity + '-' + (hasNoLocation(attrs.locationMethod) ? 'none' :
                        attrs.locationMethod.toLowerCase() +
                        (attrs.selected === 'true' ? '-selected' : '')) + '.png';
            }, true
        );
    }
}
